import { render, staticRenderFns } from "./attr-judge.vue?vue&type=template&id=2b341404&scoped=true&"
import script from "./attr-judge.vue?vue&type=script&lang=js&"
export * from "./attr-judge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b341404",
  null
  
)

export default component.exports